import http from "../http-common"

class BreadcrumbServices {
    getAllBreadcrumb(pathId:string) {
        return http.get(`/bread-crumb?path=${pathId}`)
    }
}


export default new BreadcrumbServices();